import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const WorkSchedulePersonalRequest = {
  getWorkSchedulePersonalList: (startDate, endDate) =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/work-schedule-personal`,
      headers: {
        Authorization: `Bearer ${JSON.parse(authenticationStore.appToken).access_token
          }`,
        'Content-Type': 'application/json',
      },
      params: {
        startDate: startDate,
        endDate: endDate,
      },
    }),

  getWorkSchedulePersonalListByDepartment: (startDate, endDate, department) =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/work-schedule-personal/by-department`,
      headers: {
        Authorization: `Bearer ${JSON.parse(authenticationStore.appToken).access_token
          }`,
        'Content-Type': 'application/json',
      },
      params: {
        startDate: startDate,
        endDate: endDate,
        department: department,
      },
    }),
  getDetailWorkSchedulePersonal: (workDate, executedBy) =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/work-schedule-personal/detail`,
      headers: {
        Authorization: `Bearer ${JSON.parse(authenticationStore.appToken).access_token
          }`,
        'Content-Type': 'application/json',
      },
      params: {
        workDate: workDate,
        executedBy: executedBy,
      },
    }),
  createOrUpdateWorkSchedulePersonal: data =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/work-schedule-personal`,
      headers: {
        Authorization: `Bearer ${JSON.parse(authenticationStore.appToken).access_token
          }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),

  getHistory: (username, startDate, endDate) =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/work-schedule-personal/history-by/${username}`,
      headers: {
        Authorization: `Bearer ${JSON.parse(authenticationStore.appToken).access_token
          }`,
        'Content-Type': 'application/json',
      },
      params: {
        startDate: startDate,
        endDate: endDate
      }
    }),
}
